import React, { useState } from "react";
import styles from "./UserHeader.module.scss";
import Button from "component/atom/forms/button/Button";
import { formatDateTime } from "component/molecules/Table/TableComponents/factory/factory";
import { usePost } from "hooks/usePost";
import { userEndpoints } from "hooks/endpoints";
import UserImage from "component/molecules/new-user/userImage/UserImage";
import ConfirmationModal from "component/hoc/success-modal/ConfirmationModal";
import SvgWithBranding from "component/hoc/branding/withBrandingColor.hoc";
import { useNavigate } from "react-router-dom";
const UserHeader = ({ user, id, refetchUser }) => {
  const navigate = useNavigate();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isLock, setIsLock] = useState(false);

  const { mutate: Delete, isPending } = usePost({
    onSuccessToast: "Deleted Successfully",
    toastType: "add",
  });
  const { mutate: Lock, isPending: isLocking } = usePost({
    onSuccessToast: user?.user?.[0]?.isLocked
      ? "UnLocked Successfully"
      : "Locked Successfully",
    toastType: "update",
  });
  const handleDelete = () => {
    Delete(
      {
        method: "Delete",
        url: userEndpoints?.deleteUser(id),
      },
      {
        onSuccess: () => {
          navigate(-1);
        },
      }
    );
  };
  const handleLockUser = () => {
    Lock(
      {
        method: "Put",
        url: userEndpoints?.lockUser(id, !user?.user?.[0]?.isLocked),
      },
      {
        onSuccess: () => {
          refetchUser();
        },
      }
    );
  };
  const handleCloseModal = () => {
    setIsDeleteModalOpen(false);
    setIsLock(false);
  };

  return (
    <>
      <div className={styles["header-cont"]}>
        <div className={styles.cont}>
          <div className={styles.headerSub}>
            <UserImage
              userImage={user?.userImage?.userImage}
              refetch={refetchUser}
            />
            <div className={styles["name-cont"]}>
              <h3>
                {user?.user?.[0]?.firstName + " " + user?.user?.[0]?.lastName}
                {user?.user?.[0]?.isLocked && (
                  <SvgWithBranding
                    type="lock-table"
                    color="black"
                    className={styles.lockIcon}
                  />
                )}
              </h3>
              <p>Role Name: {user?.user?.[0]?.roleName}</p>
              <p>@{user?.user?.[0]?.username}</p>
            </div>
          </div>

          <div className={styles["calender-cont"]}>
            <div className={styles["details"]}>
              <SvgWithBranding type="calender" />
              <span>
                Joined {formatDateTime(user?.user?.[0]?.joinedDate) || "-"}{" "}
              </span>
            </div>
            <div className={styles["details"]}>
              <SvgWithBranding type="logIn" />
              <span>Last Login: {formatDateTime(user?.lastLogin) || "-"}</span>
            </div>
          </div>
        </div>
        {user?.user?.[0]?.roleId !== 0 && (
          <div className={styles["calender-cont"]}>
            <Button
              label={user?.user?.[0]?.isLocked ? "Unlock User" : "Lock User"}
              opicBackground
              onClick={() => setIsLock(true)}
              type="lock"
            />
            <Button
              label="Delete User"
              variant="danger-rev"
              onClick={() => setIsDeleteModalOpen(true)}
              opicBackground={true}
              type="delete"
            />
          </div>
        )}
      </div>
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: "delete" }}
        text={`Deleting ${
          user?.user?.[0]?.firstName + " " + user?.user?.[0]?.lastName
        }`}
        subText="Will remove all their data, including associated files and permissions. Proceed?"
        type="Delete"
        isLoading={isPending}
      />
      <ConfirmationModal
        isOpen={isLock}
        onClose={handleCloseModal}
        onSubmit={handleLockUser}
        closeOnSubmit={true}
        onApproveButton={{
          text: user?.user?.[0]?.isLocked ? "Unlock" : "Lock",
        }}
        text={`${user?.user?.[0]?.isLocked ? "Unlock" : "Lock"} ${
          user?.user?.[0]?.firstName + " " + user?.user?.[0]?.lastName
        }`}
        subText={`Are you sure you want to ${
          user?.user?.[0]?.isLocked ? "unlock" : "lock"
        } this user? ${
          !user?.user?.[0]?.isLocked
            ? "They will no longer have access until unlocked."
            : ""
        }`}
        type="lock"
        isPending={isLocking}
      />
    </>
  );
};

export default UserHeader;
